import React, { useState, useEffect, forwardRef } from 'react'
import { useHistory, useLocation } from "react-router"
import IconButton from '@mui/material/IconButton'
import { Container, Button, Grid, Typography, Tooltip, Box, Snackbar, CircularProgress, LinearProgress } from "@mui/material"
import makeStyles from "@mui/styles/makeStyles"
import VisibilityOff from '@mui/icons-material/VisibilityOff'
import Visibility from '@mui/icons-material/Visibility'
import InputAdornment from '@mui/material/InputAdornment'
import OutlinedInput from '@mui/material/OutlinedInput'
import InputLabel from '@mui/material/InputLabel'
import { Person, VpnKey, Key, Help } from '@mui/icons-material'
import { FormHelperText, FormControlLabel, Checkbox } from '@mui/material'
import { cnpjMask } from './CnpjMask'
import ApartmentIcon from '@mui/icons-material/Apartment'
import MuiAlert from "@mui/material/Alert"
import TermsModal from '../terms/TermsModal'
import Helper from '../providers/Helpers'
import commandsProvider from "../providers/CommandsProvider";
import { is } from 'date-fns/locale'

const useStyles = makeStyles((theme) => {
    return {
        fonts: {
            color: "#ffffff",
        }
    }
})

const Alert = forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default function ChangePassword(props) {
    const classes = useStyles()
    const [user, setUser] = useState(localStorage.getItem("user") !== null ? JSON.parse(localStorage.getItem("user")) : {})
    const [name, setName] = useState("")
    const [password, setPassword] = useState("")
    const [nameError, setNameError] = useState(false)

    const [passwordError, setPasswordError] = useState(false)
    const [showPassword, setShowPassword] = useState(false)
    const [passwordErrorText, setPasswordErrorText] = useState("")

    const [nameErrorText, setNameErrorText] = useState("")

    const [confirmation, setConfirmation] = useState("")
    const [showPasswordConfirmation, setShowPasswordConfirmation] = useState(false)
    const [confirmationError, setConfirmationError] = useState(false)
    const [passwordConfirmationText, setPasswordConfirmationText] = useState("")

    const [cnpj, setCnpj] = useState("")
    const [cnpjError, setCnpjError] = useState(false)
    const [cnpjErrorText, setCnpjErrorText] = useState("")

    const [userNotFound, setUserNotFound] = useState(false)

    const [checked, setChecked] = useState(false)
    const [key, setKey] = useState("")
    const [secretError, setSecretError] = useState(false)
    const [secretErrorText, setSecretErrorText] = useState("")
    const [open, setOpen] = useState(false)
    const [technicianHd, setTechnicianHd] = useState("")
    const [acceptTerm, setAcceptTerm] = useState(false)
    const [severity, setSeverity] = useState("")
    const [message, setMessage] = useState("")

    const [isLoading, setIsLoading] = useState(false)
    const [submitButtonText, setSubmitButtonText] = useState("Tudo pronto! Vamos lá!")

    const history = useHistory()
    const location = useLocation()
    const hasRecoverableData = location.state?.hasRecoverableData === true ||
        sessionStorage.getItem("hasRecoverableData") === "true"

    const inputChange = (e) => {
        const { name, value } = e.target
        setCnpj(
            value
        )
    }

    const isFormValid = () => {
        const isCnpjValid = cnpj.length >= 14
        const isNameValid = name.length >= 1
        const isPasswordValid = password.length >= 8
        const isConfirmationValid = confirmation === password
        const isKeyValid = props.technician ? key.length >= 25 : true

        return isCnpjValid && 
            isNameValid && 
            isPasswordValid && 
            isConfirmationValid && 
            isKeyValid &&
            acceptTerm
    }

    const validateName = (value) => {
        if (value.length < 1) {
            setNameError(true)
            setNameErrorText("Insira um novo Nome para o Usuário Administrador!")
        } else {
            setNameError(false)
            setNameErrorText("")
        }
    }

    const validateCnpj = (value) => {
        // Remove todos os caracteres não numéricos
        const numericValue = value.replace(/\D/g, '')
        
        // Verifica se tem 14 dígitos após remover caracteres especiais
        if (numericValue.length !== 14) {
            setCnpjError(true)
            setCnpjErrorText("Insira um CNPJ válido!")
            return false
        }

        // Valida o formato XX.XXX.XXX/XXXX-XX
        const cnpjRegex = /^\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}$/
        if (!cnpjRegex.test(value)) {
            setCnpjError(true) 
            setCnpjErrorText("Formato inválido! Use XX.XXX.XXX/XXXX-XX")
            return false
        }

        setCnpjError(false)
        setCnpjErrorText("")
        return true
    }

    const validatePassword = (value) => {
        if (value.length < 8) {
            setPasswordError(true)
            setPasswordErrorText("Sua Senha deve conter no mínimo 8 caracteres!")
        } else {
            setPasswordError(false)
            setPasswordErrorText("")
        }
    }

    const validateConfirmation = (value) => {
        if (value !== password) {
            setConfirmationError(true)
            setPasswordConfirmationText("As Senhas devem ser iguais!")
        } else {
            setConfirmationError(false)
            setPasswordConfirmationText("")
        }
    }

    const validateKey = (value) => {
        if (props.technician && value.length < 25) {
            setSecretError(true)
            setSecretErrorText("Insira uma chave válida")
        } else {
            setSecretError(false)
            setSecretErrorText("")
        }
    }

    // Adicione estas funções antes do handleSubmit
    const validateFields = () => {
        if (cnpj.length < 14) {
            setCnpjError(true)
            setCnpjErrorText("Insira um CNPJ válido!")
            return false
        }

        if (name.length < 1) {
            setNameError(true)
            setNameErrorText("Insira um novo Nome para o Usuário Administrador!")
            return false
        }

        if (password.length < 8) {
            setPasswordError(true)
            setPasswordErrorText("Sua Senha deve conter no mínimo 8 caracteres!")
            return false
        }

        if (confirmation !== password) {
            setConfirmationError(true)
            setPasswordConfirmationText("As Senhas devem ser iguais!")
            return false
        }

        if (props.technician && key.length < 25) {
            setSecretError(true)
            setSecretErrorText("Insira sua chave")
            return false
        }

        return true
    }

    const activateTechnicianLicense = async () => {
        const response = await fetch(`${process.env.REACT_APP_URL}/licences/activate/technician?key=${key}`, {
            method: "GET",
            headers: { "content-type": "application/json" }
        })
        const data = await response.json()
        
        switch(data.message) {
            case "Success":
                setSeverity("success")
                setOpen(true)
                setMessage("Licença ativada com sucesso")
                return true
            case "Used":
                setSeverity("error")
                setOpen(true)
                setMessage("Esta chave já está em uso. Adquira uma nova chave!")
                return false
            case "Error":
                setSeverity("error")
                setOpen(true)
                setMessage("Erro ao ativar licença!")
                return false
            case "NotFound":
                setSeverity("error")
                setOpen(true)
                setMessage("Chave não encontrada!")
                return false
            case "Invalid":
                setSeverity("error")
                setOpen(true)
                setMessage("Chave Inválida.")
                return false
            default:
                return false
        }
    }

    const createUserRoles = (isTechnician) => ({
        "ID": user.id,
        "upload": true,
        "editar": true,
        "alarmes": !isTechnician,
        "relatorio": true,
        "usuarios": true,
        "admin": true,
        "delta": false,
        "revenda": false,
        "tecnico": isTechnician,
        "light": false,
        "notEditable": true,
        "multiCentral": false
    })

    const updateUserFirstLogin = async (roles) => {
        const response = await fetch(`${process.env.REACT_APP_URL}/user/firstlogin`, {
            method: "POST",
            headers: { "content-type": "application/json" },
            body: JSON.stringify({
                "ID": user.id,
                "DS_NOME": name,
                "SENHA": password,
                "ROLE": roles,
                "ID_INTRANET": 0,
                "DS_CNPJ": cnpj.replace(/[.-/]/g, ""),
            })
        })
        return await response.json()
    }

    const handleLogin = async () => {
        const response = await fetch(`${process.env.REACT_APP_URL}/account/login`, {
            method: "POST",
            headers: { "content-type": "application/json" },
            body: JSON.stringify({
                name: name,
                password: password,
                encript: false
            })
        })

        if (response.status === 404) {
            setUserNotFound(true)
            return false
        }

        const data = await response.json()
        
        if (data.message)
        {
            console.log("handleLogin -> request Response:", data.message);
            props.token.setToken(data.message)
            return false
        }

        localStorage.setItem("user", JSON.stringify(data.user))
        localStorage.setItem("token", data.token)
        
        props.data.setToken(data.token)
        const session = Helper.ConvertUserToSession(data.user)
        if (session) {
            commandsProvider.setSession(session)
            props.data.setUserData(session)
        } else {
            // fallback para localStorage se necessário
            const sessionFromStorage = Helper.ConvertUserToSession(Helper.GetUserFromLocalStorage())
            if (sessionFromStorage) {
                commandsProvider.setSession(sessionFromStorage)
                props.data.setUserData(sessionFromStorage)
            }
        }
        props.data.populateData(data.user, data.token)
        
        return true
    }

    // Novo handleSubmit
    const handleSubmit = async (e) => {
        e.preventDefault()
        
        try {
            setIsLoading(true)

            if (!validateFields()) {
                return
            }

            if (props.technician) {
                setSubmitButtonText("Validando licença...")
                const licenseActivated = await activateTechnicianLicense()
                if (!licenseActivated) return
            }

            setSubmitButtonText("Atualizando dados...")
            const roles = createUserRoles(props.technician)
            await updateUserFirstLogin(roles)
            
            setSubmitButtonText("Autenticando...")
            const loginSuccess = await handleLogin()
            if (loginSuccess) {
                setSubmitButtonText("Redirecionando...")
                history.push("/central")
            }

        } catch (error) {
            console.error('Error:', error)
            setSeverity("error")
            setOpen(true)
            setMessage("Ocorreu um erro ao processar sua requisição")
        } finally {
            setIsLoading(false)
            setSubmitButtonText("Tudo pronto! Vamos lá!")
        }
    }

    const setVisible = () => {
        setShowPassword(!showPassword)
    }

    const setConfirmationVisible = () => {
        setShowPasswordConfirmation(!showPasswordConfirmation)
    }

    const keyLength = (e) => {
        if (e.length >= 24) {
            setKey(e)
        }
    }

    const handleTechnicianBox = () => {
        setChecked(!checked)
        fetch(`${process.env.REACT_APP_URL}/account/hdd`, {
            method: "GET",
            headers: { "content-type": "application/json" },
        }).then(response => response.json())
            .then(data => setTechnicianHd(data.message))

        setKey("")
    }

    useEffect(() => {
        if (props.technician === true) {
            fetch(`${process.env.REACT_APP_URL}/account/hdd`, {
                method: "GET",
                headers: { "content-type": "application/json" },
            }).then(response => response.json())
                .then(data => setTechnicianHd(data.message),
                    console.log(technicianHd))
                
            setKey("")
        }
    }, [])

    return (
        <Container sx={{ mt: "2rem", mb: "2rem", position: 'relative' }}>
            <Snackbar
                open={open}
                autoHideDuration={6000}
                placement="right"
                onClose={() => setOpen(!open)}>
                <Alert severity={severity} sx={{ width: '100%' }}>{message}</Alert>
            </Snackbar>

            {isLoading &&
                <LinearProgress color='secondary' sx={{ position: 'fixed', width: '100vw', top: 0, left: 0 }} />
            }

            <form noValidate autoComplete="off" onSubmit={handleSubmit}>
                <Grid container spacing={2}>
                    <Grid justifyContent="center" alignItems="center" item xs={12} md={12} lg={12}>
                        <Typography className={classes.fonts} variant='h3'>Este é seu Primeiro Acesso!</Typography>
                        <Typography className={classes.fonts} variant='body1'>Para prosseguir você precisa alterar o nome e a senha do Usuário "Administrador" do Sistema Guardião 2.0.</Typography>
                        {hasRecoverableData && (
                            <Box sx={{
                                backgroundColor: '#1565c0',
                                borderRadius: '8px',
                                padding: '0.75rem 1.25rem',
                                marginTop: '1rem'
                            }}>
                                <Typography sx={{ color: '#fff', fontSize: '0.9rem' }}>
                                    ✅ Dados históricos detectados — central, amplificadores, eventos e registros serão preservados automaticamente após a configuração.
                                </Typography>
                            </Box>
                        )}
                    </Grid>

                    <Grid item xs={12}>
                        <InputLabel sx={{ color: "#ffffff" }} htmlFor="usern-name">Alterar Nome do Usuário "Administrador":</InputLabel>
                        <OutlinedInput
                            autoFocus={true}
                            id="usern-name"
                            onChange={(e) => {
                                setName(e.target.value)
                                validateName(e.target.value)
                            }}
                            onBlur={(e) => validateName(e.target.value)}
                            variant="outlined"
                            color="secondary"
                            required
                            error={nameError}
                            fullWidth={true}
                            startAdornment={
                                <InputAdornment position="start">
                                    <Person />
                                </InputAdornment>
                            }
                            disabled={isLoading}
                        ></OutlinedInput>
                        <FormHelperText id="user-name">{nameErrorText || "Campo obrigatório"}</FormHelperText>
                    </Grid>

                    <Grid item xs={12} md={6} lg={6}>
                        <InputLabel sx={{ color: "#ffffff" }} htmlFor="outlined-adornment-password">Insira uma Nova Senha para o Usuário "Administrador":</InputLabel>
                        <OutlinedInput
                            required
                            onChange={(e) => setPassword(e.target.value)}
                            onBlur={(e) => validatePassword(e.target.value)}
                            id="password"
                            type={showPassword ? "text" : "password"}
                            error={passwordError}
                            fullWidth={true}
                            startAdornment={
                                <InputAdornment position="start">
                                    <VpnKey />
                                </InputAdornment>
                            }
                            endAdornment={
                                <InputAdornment position="end">
                                    <IconButton
                                        aria-label="toggle password visibility"
                                        onClick={setVisible}
                                        edge="end"
                                    >
                                        {showPassword ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                </InputAdornment>
                            }
                            disabled={isLoading}
                        />
                        <FormHelperText id="password">{"Sua senha deve conter no mínimo 8 caracteres"}</FormHelperText>
                    </Grid>

                    <Grid item xs={12} md={6} lg={6}>
                        <InputLabel sx={{ color: "#ffffff" }} htmlFor="outlined-adornment-password">Confirme a Senha:</InputLabel>
                        <OutlinedInput
                            required
                            onChange={(e) => {
                                setConfirmation(e.target.value)
                                validateConfirmation(e.target.value)
                            }}
                            onBlur={(e) => validateConfirmation(e.target.value)}
                            id="confirmation"
                            type={showPasswordConfirmation ? "text" : "password"}
                            error={confirmationError}
                            fullWidth={true}
                            startAdornment={
                                <InputAdornment position="start">
                                    <VpnKey />
                                </InputAdornment>
                            }
                            endAdornment={
                                <InputAdornment position="end">
                                    <IconButton
                                        aria-label="toggle password visibility"
                                        onClick={setConfirmationVisible}
                                        edge="end"
                                    >
                                        {showPassword ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                </InputAdornment>
                            }
                            disabled={isLoading}
                        />
                        <FormHelperText id="password">{passwordConfirmationText}</FormHelperText>
                    </Grid>

                    <Grid item xs={12}>
                        <InputLabel sx={{ color: "#ffffff" }} htmlFor="outlined-adornment-password">Insira o CNPJ da empresa:</InputLabel>
                        <OutlinedInput
                            required
                            onChange={inputChange}
                            onBlur={(e) => validateCnpj(e.target.value)}
                            id="cnpj"
                            value={cnpjMask(cnpj)}
                            error={cnpjError}
                            fullWidth={true}
                            startAdornment={
                                <InputAdornment position="start">
                                    <ApartmentIcon />
                                </InputAdornment>
                            }
                            disabled={isLoading}
                        />
                        <FormHelperText id="password">{cnpjErrorText || "Campo obrigatório"}</FormHelperText>
                    </Grid>

                    {/* {props.technician
                        ?
                        <Grid item xs={12} md={12} lg={12}>
                            <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={checked}
                                            onChange={handleTechnicianBox}
                                        />
                                    }
                                    label={"Habilitar licença para tecnico"}
                                />
                                <Tooltip title={"Habilite esta opção se você quiser utilizar este Guardião apensas para uso técnico"}><Help color="primary" /></Tooltip>
                            </Box>
                        </Grid>
                        : null} */}

                    {props.technician
                        ?
                        <Grid item xs={12}>
                            <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", marginBottom: "1rem" }}>
                                <Typography color="#ffffff" variant="body1" >Key {technicianHd}</Typography>
                                <Tooltip title={"Informe esta Key ao Suporte Delta Fire para Gerar a sua Licença de Técnico!"}><Help color="primary" /></Tooltip>
                            </Box>

                            <InputLabel sx={{ color: "#ffffff" }} className={classes.fonts} htmlFor="outlined-adornment-password">Insira sua Chave para Licença de Técnico:</InputLabel>
                            <OutlinedInput
                                id="secret-key"
                                onChange={(e) => {
                                    keyLength(e.target.value)
                                    validateKey(e.target.value)
                                }}
                                onBlur={(e) => validateKey(e.target.value)}
                                variant="outlined"
                                color="secondary"
                                required
                                error={secretError}
                                fullWidth={true}
                                startAdornment={
                                    <InputAdornment position="start">
                                        <Key />
                                    </InputAdornment>
                                }
                                disabled={isLoading}
                            ></OutlinedInput>
                            <FormHelperText id="secret-key">{secretErrorText || "Campo obrigatório"}</FormHelperText>
                        </Grid>
                        : null}

                    <Grid item xs={12} md={12} lg={12}>
                        <TermsModal technician={checked} ressale={false} multiUser={false} setAcceptTerm={setAcceptTerm} />
                    </Grid>

                    <Grid item container sx={{ mt: '10px'}}>
                        <Grid item xs={12} sm={6} md={4} lg={3}>
                            <Button
                                fullWidth
                                variant="contained"
                                color="primary"
                                onClick={() => history.goBack()}
                                sx={{ height: '100%' }}
                                disabled={isLoading}
                            >
                                Voltar
                            </Button>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={3} sx={{ marginLeft: { xs: 0, sm: 'auto' } }}>
                            <Button
                                fullWidth
                                type="submit"
                                color="secondary"
                                variant="contained"
                                disabled={!isFormValid() || isLoading}
                                sx={{ 
                                    height: '100%',
                                    display: 'flex', 
                                    gap: 1 
                                }}
                            >
                                {submitButtonText}
                                {isLoading && <CircularProgress size={20} color="inherit" />}
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
            </form>
        </Container>
    );
}